module.exports = __webpack_public_path__ + "static/dip-video-player-desktop.1e88d7be.webp";